export default __webpack_public_path__ + "static/media/404.c598b7d5.png";